<script>
    import { onMount } from 'svelte';
    import { on } from 'svelte/events';

    import { ApiClient } from '../../ApiClient.js';
    import JASSUB from 'jassub';

    const workerUrl = '/subtitles/jassub/jassub-worker.js';
    const wasmUrl = '/subtitles/jassub/jassub-worker.wasm';
    const modernWasmUrl = '/subtitles/jassub/jassub-worker-modern.wasm';
    const legacyWasmUrl = '/subtitles/jassub/jassub-worker.wasm.js';
    const fontUrl = '/subtitles/jassub/default.woff2';

    const baseUrl = () => window.location.origin;
    const subUrl = async (url) => {
        const { error, data } = await ApiClient.tryFindSubtitles(url);
        if (error) return null;
        return data.subtitleUrl;
    };

    let currentMediaUrl = $state('');

    /** @type {{value: JASSUB | null}} */
    let renderer = $state({ value: null });
    let rendererListenerCleanup = $state({ value: null });

    const isUrlSupported = async (url) => {
        const { error } = await ApiClient.tryFindSubtitles(url);

        return !error || error.status !== 422;
    };

    /**
     *
     */
    function clearRenderer() {
        if (renderer.value) {
            renderer.value.destroy();
            renderer.value = null;
        }
        if (rendererListenerCleanup.value) {
            rendererListenerCleanup.value();
            rendererListenerCleanup.value = null;
        }
        currentMediaUrl = '';   // <-- add this
    }

    /**
     *
     * @param _
     */
    function onRendererError(_) {
        clearRenderer();
    }

    /**
     *
     * @param video
     * @param mediaUrl
     */
    async function createRenderer(video, mediaUrl) {
        /**@type {import('jassub').JassubOptions}*/
        const options = {
            video: video,
            subUrl: await subUrl(mediaUrl),
            workerUrl: baseUrl() + workerUrl,
            wasmUrl: baseUrl() + wasmUrl,
            legacyWasmUrl: baseUrl() + legacyWasmUrl,
            modernWasmUrl: baseUrl() + modernWasmUrl,
            availableFonts: {
                'liberation sans': baseUrl() + fontUrl
            },
            useLocalFonts: true,
            debug: false
        };

        return new JASSUB(options);
    }

    onMount(() => {
        const interval = setInterval(async () => {
            const titleDataLink = document.querySelector('.queue_active a.qe_title');
            if (titleDataLink) {
                const mediaUrl = titleDataLink.getAttribute('href');
                if (!mediaUrl) {
                    return;
                }

                const videoElement = document.querySelector('video');
                if (!videoElement) {
                    return;
                }

                if (renderer.value && mediaUrl === currentMediaUrl) {
                    // TODO(rite): check version change
                    return;
                }
                if (await isUrlSupported(mediaUrl)) {
                    if (renderer.value) {
                        // TODO(rite): fix
                        renderer.value.setTrackByUrl(await subUrl(mediaUrl));
                    } else {
                        renderer.value = await createRenderer(videoElement, mediaUrl);
                        rendererListenerCleanup.value = on(renderer.value, 'error', onRendererError);
                    }
                } else {
                    clearRenderer();
                }
                currentMediaUrl = mediaUrl;
            }
        }, 2000);

        // just to avoid errors in console from jassub
        const cleanupOnClick = on(document.getElementById('mediarefresh'), 'click', () => clearRenderer());

        return () => {
            clearRenderer();
            clearInterval(interval);
            cleanupOnClick();
        };
    });
</script>
